import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { finalize, lastValueFrom } from 'rxjs';

import { Pessoa } from '../../../../models/Pessoa';
import { PessoasService } from '../../../../services/pessoa/pessoas.service';
import { getPaginatorIntl } from '../../../../shared/mat-paginator-intl';

/**
 * AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH!
 * AJUSTAR AQUI O BLOQUEADO E O SELECIONAR TAMBÉM,
 */

interface PessoaTable extends Pessoa {
  selecionada?: boolean;
}

@Component({
  selector: 'app-selecionar-pessoas.component',
  imports: [
    MatProgressSpinnerModule,
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
  ],
  templateUrl: './selecionar-pessoas.component.html',
  styleUrl: './selecionar-pessoas.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [{ provide: MatPaginatorIntl, useFactory: getPaginatorIntl }],
})
export class SelecionarPessoasComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public isLoading = false;
  pessoas = new MatTableDataSource<PessoaTable>();
  listaCompleta: any[] = [];

  colunasTabela = [
    { id: 'nomeCompleto', header: 'Nome', propriedade: 'nomeCompleto' },
    {
      id: 'numeroDocumento',
      header: 'Documento',
      propriedade: 'numeroDocumento',
    },
    { id: 'cargo', header: 'Cargo', propriedade: 'cargo' },
    {
      id: 'telefoneCelular',
      header: 'Telefone',
      propriedade: 'telefoneCelular',
    },
    {
      id: 'empresaNomeFantasia',
      header: 'Empresa',
      propriedade: 'empresaNomeFantasia',
    },
  ];

  listaEmpresas: { id: number; nomeFantasia: string }[] = [];
  empresasSelecionadas: number[] = [];
  pessoasSelecionadas: Pessoa[] = [];
  pessoasBloqueadas: Pessoa[] = [];
  pessoasSelecionadasLocal: Pessoa[] = [];

  pageSize = 10;
  pageSizeOptions = [5, 10, 15];
  total = 0;
  inicio = 1;
  fim = 10;

  get displayedColumns(): string[] {
    return ['selecionar', ...this.colunasTabela.map((coluna) => coluna.id)];
  }

  constructor(
    private pessoasService: PessoasService,
    public dialogRef: MatDialogRef<SelecionarPessoasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  pessoaSelecionada = (pessoa: PessoaTable): boolean => {
    const pessoaSelecionadaManualmente =
      this.pessoasSelecionadas.some((p) => p.idPessoa === pessoa.idPessoa) ||
      this.pessoasSelecionadasLocal.some((u) => u.idPessoa === pessoa.idPessoa);

    const grupoBuscandoPessoas = this.data.grupos
      .filter((g: any) => g.buscaPessoas)
      .some((g: any) => g.idGrupo === pessoa.idGrupo);

    const empresasBuscandoPessoas = this.data.empresas
      .filter((e: any) => e.buscaPessoas)
      .some((e: any) => e.idEmpresa === pessoa.idEmpresa);

    return (
      grupoBuscandoPessoas ||
      empresasBuscandoPessoas ||
      pessoaSelecionadaManualmente
    );
  };

  pessoaBloqueada = (pessoa: PessoaTable): boolean => {
    const grupoBuscandoPessoas = this.data.grupos
      .filter((g: any) => g.buscaPessoas)
      .some((g: any) => g.idGrupo === pessoa.idGrupo);

    const empresasBuscandoPessoas = this.data.empresas
      .filter((e: any) => e.buscaPessoas)
      .some((e: any) => e.idEmpresa === pessoa.idEmpresa);

    return grupoBuscandoPessoas || empresasBuscandoPessoas;
  };

  async ngOnInit(): Promise<void> {
    this.pessoasSelecionadasLocal = [...(this.data.pessoas || [])];
    this.isLoading = true;

    await this.buscarPessoasAPI();
    this.configurarFiltros();
    this.configurarEmpresas();
  }

  ngAfterViewInit(): void {
    this.pessoas.paginator = this.paginator;
    this.pessoas.sort = this.sort;
    // this.paginator.page.subscribe((event) => this.onPageChange(event));
  }

  async buscarPessoasAPI() {
    try {
      const pessoas = await this.pessoasService.buscarPessoasPorEmpresaEGrupo(
        this.data.empresasVinculadas,
        null
      );
      
      this.isLoading = false;

      this.listaCompleta = pessoas.map((p) => ({
        ...p,
        selecionada: this.pessoaSelecionada(p),
        bloqueado: this.pessoaBloqueada(p),
      }));

      this.pessoas.data = [...this.listaCompleta];
      this.total = this.pessoas.data.length;
      this.atualizarContagem(0, this.pageSize);
    } catch (error) {
      console.error('Erro ao buscar pessoas:', error);
      this.pessoas.data = [];
      this.isLoading = false;
    }
  }

  private configurarEmpresas() {
    const empresasUnicas = new Map<
      number,
      { id: number; nomeFantasia: string }
    >();

    this.listaCompleta.forEach((p) => {
      if (p.idEmpresa && p.empresaNomeFantasia) {
        empresasUnicas.set(p.idEmpresa, {
          id: p.idEmpresa,
          nomeFantasia: p.empresaNomeFantasia,
        });
      }
    });

    this.listaEmpresas = Array.from(empresasUnicas.values());
    this.empresasSelecionadas = []; // Nenhuma empresa selecionada por padrão
  }

  private configurarFiltros() {
    this.pessoas.filterPredicate = (
      data: PessoaTable,
      filter: string
    ): boolean => {
      const termo = filter.trim().toLowerCase();
      return (
        (data.nomeCompleto || '').toLowerCase().includes(termo) ||
        (data.numeroDocumento || '').toLowerCase().includes(termo)
      );
    };
  }

  filtrarPorEmpresa() {
    if (this.empresasSelecionadas.length === 0) {
      this.pessoas.data = [...this.listaCompleta]; // Mostra todas quando nenhum filtro
    } else {
      this.pessoas.data = this.listaCompleta.filter(
        (p) => p.idEmpresa && this.empresasSelecionadas.includes(p.idEmpresa)
      );
    }
    this.total = this.pessoas.data.length;
    this.atualizarContagem(0, this.pageSize);
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.atualizarContagem(event.pageIndex, event.pageSize);
  }

  atualizarContagem(pageIndex: number, pageSize: number) {
    this.inicio = pageIndex * pageSize + 1;
    this.fim = Math.min((pageIndex + 1) * pageSize, this.total);
  }

  updateFieldText(event: Event) {
    const query = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.pessoas.filter = query;
  }

  alternarPessoaSelecionada(pessoa: PessoaTable, isChecked: boolean): void {
    if (this.pessoaBloqueada(pessoa)) return;

    pessoa.selecionada = isChecked;

    if (isChecked) {
      this.pessoasSelecionadasLocal.push(pessoa);
    } else {
      this.pessoasSelecionadasLocal = this.pessoasSelecionadasLocal.filter(
        (p) => p.idPessoa !== pessoa.idPessoa
      );
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    const pessoasConfirmadas = this.pessoasSelecionadasLocal.filter(
      (p) => !this.pessoaBloqueada(p as Pessoa)
    );

    this.dialogRef.close([pessoasConfirmadas]);
  }
}
